<template>
	    <div class="footer flex align-cen">
                <div class="">
                <p>北京和隆优化科技股份有限公司</p>
                <p>© 2014-2020北京和隆优化科技股份有限公司 版权所有 京ICP备15057915</p>
            </div>
            <div class="mft">
                客服电话：<span>400-8811-519</span>
            </div>
        </div>
</template>

<script>
    export default {
        name:'rts_footer',
        props: {},
        data() {
            return {
            }
        },
        computed: {
        },
        created() {
        },
        mounted() {},
        watch: {},
        methods: {
        // this.$bus.$emit("sendMsg", this.flag);
        },
        components: {  },
        // destroyed(){
        //     this.$bus.$off('sendMsg')
        // }
    }
</script>

<style scoped lang="scss">
.footer{
    width: 100%;
    height: 60px;
    .footer-top{
        height: 240px;
        width: 100%;
        background-image: linear-gradient(
		#f8fbff, 
		#f8fbff), 
	linear-gradient(
		#32333b, 
		#32333b);
	background-blend-mode: normal, 
		normal;
        .topflex{
            width: $width;
            height: inherit;
            margin: 0 auto;
            .fl1{
                width: 33.3%;
                text-align: center;
                 .fl1-text{
                    font-family: 'MicrosoftYaHei';
                    font-size: 14px;
                    font-weight: normal;
                    font-stretch: normal;
                    line-height: 32px;
                    letter-spacing: 0px;
                    color: #787878;
                    
                 }
                   .fl1-tit{
                    font-size: 20px;
                    line-height: 38px;
                }
            }
        }
    }
    .footer-bot{
        width: 100%;
        height: 50px;
        line-height: 50px;
        color: #787878;
        font-size: 14px;
        text-align: center;
    }
}
</style>
